import { useCallback, useContext, useState } from 'react'
import { CgGym } from 'react-icons/cg'

import {
  numberToBRL,
  sumTotalItemsValue,
  translatePaymentInterval,
} from '~/modules/sales/services'
import { getLocalDate } from '~/utils/getLocalDate'

import { subscriptionsContext } from '../..'
import { SubscriptionModal } from './SubscriptionModal'

export const ActiveSubscription: React.FC = () => {
  const { isValid, subscription } = useContext(subscriptionsContext)
  const [open, setOpen] = useState<boolean>(false)

  const handleOpen = useCallback(() => {
    setOpen(true)
  }, [])

  const handleClose = useCallback(() => {
    setOpen(false)
  }, [])

  return subscription ? (
    <>
      <div className='flex border-2 bg-slate-50 bg-opacity-30 rounded-xl overflow-hidden'>
        <div className='h-full w-1.5 bg-gpa-blue-500'></div>
        <div className='flex py-4 pl-2 text-gpa-blue-500'>
          <CgGym size={28} />
        </div>
        <div className='flex flex-col gap-2 p-4 flex-1 items-start'>
          <div className='flex justify-between items-center w-full'>
            <div className='flex flex-1 justify-between'>
              <h2 className='text-xl font-bold'>
                Plano{' '}
                {subscription.plan?.name ?? subscription.metaData?.planName}
              </h2>
              {!isValid ? (
                <span className='px-2 py-1 text-gpa-red bg-red-100 bg-opacity-20 rounded-md border border-red-200'>
                  {subscription.status === 'canceled'
                    ? 'Cancelada'
                    : new Date(subscription.termEnd) < new Date()
                    ? 'Expirada/Atrasada'
                    : 'Inativa'}
                </span>
              ) : null}
              {subscription.paymentStatus === 'pending' ? (
                <span className='py-1 px-3 rounded-lg text-gpa-red bg-red-100'>
                  {subscription?.paymentStatus === 'pending'
                    ? 'Aguardando pagamento'
                    : 'Pago'}
                </span>
              ) : null}
            </div>
          </div>
          <p>
            <span className='font-semibold'>Número de licenças</span>:{' '}
            {subscription.plan?.licensesAmount ||
              subscription.metaData.licensesAmount}
          </p>
          <p>
            Valor:{' '}
            {numberToBRL(
              sumTotalItemsValue(subscription.plan?.metaData.items) / 100,
            )}
            {subscription.subscriptionDiscount?.length ? '* ' : ' '}
            &bull; Cobrado{' '}
            {translatePaymentInterval(
              subscription.plan?.interval,
              subscription.plan?.intervalCount,
            )}
          </p>
          {subscription.subscriptionDiscount?.length ? (
            <p>* Descontos aplicados</p>
          ) : null}

          <div className='flex items-center justify-between w-full'>
            <button
              type='button'
              className='px-3 py-2 bg-gpa-blue-500 rounded-lg font-semibold
              text-white hover:bg-[rgb(48,137,226)] transition-colors
                duration-200'
              onClick={handleOpen}
            >
              Ver detalhes
            </button>
            {subscription.status === 'canceled' ? (
              <p className='ml-auto'>
                Acesso disponível até {getLocalDate(subscription.termEnd)}
              </p>
            ) : null}
          </div>
        </div>
      </div>

      <SubscriptionModal visible={open} onClose={handleClose} />
    </>
  ) : null
}
